import { render, staticRenderFns } from "./NewText.vue?vue&type=template&id=29266f79&scoped=true&"
import script from "./NewText.vue?vue&type=script&lang=js&"
export * from "./NewText.vue?vue&type=script&lang=js&"
import style0 from "./NewText.vue?vue&type=style&index=0&id=29266f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29266f79",
  null
  
)

export default component.exports